import * as api from '../api/adapters/json_api';

// FIN-1302: the departments of the office, in the server's order, each saying whether the
// signed-in user belongs to it. Read only — the admin edits the catalogue in Rails Admin.
const type = 'api_resources/departments';

export default {
  index: () => api.read({ type }, { query: {} })
    .then((response) => (response.data.data || []).map(({ id, attributes }) => ({ id, ...attributes }))),
};
